import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { openCart, setCart } from "../../redux";
import { LangContext } from "../../context/LangContext";
import { useCheckCart } from "../../hooks/useCheckCart";
import BtnReturn from "../../components/BtnReturn";
import BtnCart from "../../components/BtnCart";
import Slider from "../../components/Slider";
import Textarea from "../../components/Textarea";
import Payments from "../../payments";
import "./style.css"

function Articles() {
    const { slug } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const checkCart = useCheckCart();

    const cart = useSelector(state => state.cart);
    const cartIsOpen = useSelector(state => state.options.cartIsOpen);
    const { language, translations } = useContext(LangContext);

    const [quantity, setQuantity] = useState(1);
    const [selected, setSelected] = useState(null);
    const [article, setArticle] = useState(null);
    const [animCart, setAnimCart] = useState('');

    useEffect(() => {
        const fetchArticle = async () => {
            const req = await fetch(`${process.env.REACT_APP_API_URL}/articles/get/${slug}`);
            const res = await req.json();

            if (req.status !== 200) {
                alert(res.message);
                return
            };

            if (res?.selectors.length !== 0) setSelected(0);
            setArticle(res);
            checkCart();
        }
        fetchArticle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [slug]);

    if (!article) return (<div></div>)

    const verif1 = article.multi_qty !== undefined && article.selectors.length !== 0;
    const verif2 = article.multi_qty === undefined && article.selectors.length === 0;
    const verif = verif1 || verif2;

    function formatDecimal(value) {
        const num = Number(value);
        if (Number.isNaN(num)) {
            navigate('/error');
            return
        };

        // arrondi à 2 décimales, puis on reformate
        return (
            num.toFixed(2)                  // "123456.00"
                .replace('.', ',')          // étape intermédiaire pour la regex
                .replace(/\B(?=(\d{3})+(?!\d))/g, ' ') // séparateur de milliers
                .replace(',', '.')          // on remet le point
        );
    }

    function updateQuantity(e) {
        if (e.target.value <= 0) return
        setQuantity(e.target.value);
    }

    const addToCart = () => {
        if (quantity <= 0) return
        let newCart = [...cart];

        const alreadyExistingIndex = newCart.findIndex((a) => {
            if (a.title_path !== article.title_path) return false;
            if (article.selectors?.length) {
                return a.category_fr === article.selectors[selected]?.name_fr;
            }
            return true;
        });

        if (alreadyExistingIndex === -1) {
            const newItem = {
                id: article._id,
                title_path: article.title_path,
                title_fr: article.title_fr,
                title_en: article.title_en,
                image: article.images[0] || null,
                price: article.price,
                weight: article.weight,
                quantity: Number(quantity),
                exist: true,
            };


            if (article.selectors?.length && selected !== null) {
                newItem.category_fr = article.selectors[selected].name_fr;
                newItem.category_en = article.selectors[selected].name_en;
            }

            newCart.push(newItem);
        }
        else {
            const updatedItem = {
                ...newCart[alreadyExistingIndex],
                quantity: Number(newCart[alreadyExistingIndex].quantity) + Number(quantity),
                exist: true,
            };
            newCart[alreadyExistingIndex] = updatedItem;
        }

        localStorage.setItem("cart_vanrah", JSON.stringify(newCart));
        dispatch(setCart(newCart));
        window.scrollTo(0, 0);

        setAnimCart("anim_cart");
        setTimeout(() => setAnimCart(""), 1700);
    };

    const reqAddToCart = () => {
        if (quantity <= 0) return

        const lastLength = parseInt(cart.length);
        addToCart();

        if (lastLength === 0) dispatch(openCart(true));
    }

    return article && verif && (
        <div className='page page_articles'>
            <BtnReturn to='shop' />
            <BtnCart anim={animCart} />

            <p className="title_page">-<span>{article[`title_${language}`]}</span>-</p>

            <section className="sect_presentation">
                <Slider images={article.images} show={true} />

                <div className="article_descrip">
                    <Textarea
                        label={translations.detail_and_descrip}
                        text={article[`descrip_${language}`]}
                    />


                    <p className="price">
                        <span>{translations.price} :</span>
                        {formatDecimal(article.price)} €
                    </p>

                    {selected !== null &&
                        <div className="selector">
                            <span>{article[`category_${language}`]} :</span>

                            <select value={selected} onChange={(e) => setSelected(e.target.value)}>
                                {article.selectors.map((category, idx) =>
                                    <option key={idx} value={idx}>{category[`name_${language}`]}</option>
                                )}
                            </select>
                        </div>
                    }

                    <div className="panel">
                        <div className="quantity">
                            <span>{translations.quantity} :</span>

                            <input
                                type="number"
                                value={quantity}
                                placeholder="0"
                                onChange={(e) => updateQuantity(e)}
                            />
                        </div>

                        {/* <button className='add_to_cart' onClick={() => reqAddToCart()}>
                            {translations.add_to_cart}
                        </button> */}
                    </div>
                </div>
            </section>

            {/* {cartIsOpen && <Payments />} */}
        </div>
    )
}

export default Articles;